import React from 'react';
import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom';
import { useAuthContext } from './context/AuthContext';
import { CandidateDetailPage } from './pages/embeddings/CandidateDetailPage';
import { CandidatesPage } from './pages/embeddings/CandidatesPage';
import EmbeddingDetailPage from './pages/embeddings/EmbeddingDetailPage';
import { EmbeddingsPage } from './pages/embeddings/EmbeddingsPage';
import { StoreDetailsPage } from './pages/store-details/StoreDetailsPage';
import StoresPage from './pages/stores/StoresPage';
import { TaskDetailPageWrapper } from './pages/tasks/TaskDetailPageWrapper';
import { TasksPage } from './pages/tasks/TasksPage';

const RootRedirect: React.FC = () => {
  const { hasInternalAccess } = useAuthContext();
  return <Navigate to={hasInternalAccess ? '/stores' : '/embeddings/detail'} replace />;
};

const ProtectedRoute: React.FC<{ element: React.ReactElement }> = ({ element }) => {
  const { hasInternalAccess } = useAuthContext();

  if (!hasInternalAccess) {
    return <Navigate to="/embeddings/detail" replace />;
  }

  return element;
};

const router = createBrowserRouter([
  {
    path: '/',
    element: <RootRedirect />,
  },
  {
    path: '/stores',
    element: <ProtectedRoute element={<StoresPage />} />,
  },
  {
    path: '/stores/:storeName/:deviceName?',
    element: <ProtectedRoute element={<StoreDetailsPage />} />,
  },
  {
    path: '/embeddings',
    element: <ProtectedRoute element={<EmbeddingsPage />} />,
  },
  {
    path: '/embeddings/detail',
    element: <EmbeddingDetailPage />,
  },
  {
    path: '/tasks',
    element: <ProtectedRoute element={<TasksPage />} />,
  },
  {
    path: '/tasks/:taskId',
    element: <ProtectedRoute element={<TaskDetailPageWrapper />} />,
  },
  {
    path: '/embeddings/candidates',
    element: <ProtectedRoute element={<CandidatesPage />} />,
  },
  {
    path: '/embeddings/candidates/:imageId',
    element: <CandidateDetailPage />,
  },
]);

export const App: React.FC = () => {
  return <RouterProvider router={router} />;
};
